// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-menu-js": () => import("./../../../src/pages/menu.js" /* webpackChunkName: "component---src-pages-menu-js" */),
  "component---src-pages-slideshow-js": () => import("./../../../src/pages/slideshow.js" /* webpackChunkName: "component---src-pages-slideshow-js" */),
  "component---src-pages-touchscreen-js": () => import("./../../../src/pages/touchscreen.js" /* webpackChunkName: "component---src-pages-touchscreen-js" */)
}

